import React from "react";
import { Col, Modal, Row } from "antd";
import { useParams } from "react-router-dom";

import RegisterForm from "../Forms/RegisterForm";
import CloseIcon from "../../assets/closeIcon.svg";

import useIcons from "../../utils/useIcons";
import useMapData from "../../utils/useMapData";

import "../HomeSection/HomeSection.scss";
import "../Modal/Modal.scss";

export const ModalOverlay = ({
  isModalVisible,
  handleModalVisibility,
  title = "Download Brochure",
  subTitle = "Register Here And Avail The Best Offers!!",
  btnText = "Download Now",
  actionType,
}) => {
  const { propertyId } = useParams();

  const resultList = useMapData(propertyId);

  const { CarVisitIcon, ContactUsIcon, LowPriceIcon } = useIcons(
    resultList?.themeColor
  );

  const bodyStyles = {
    background: "#F9F7F7",
    border: " 0.5px solid rgba(255, 255, 255, 0.2)",
  };

  console.log(title);

  return (
    <>
      <Modal
        centered
        visible={isModalVisible}
        closable={false}
        maskClosable
        onCancel={handleModalVisibility}
        footer={null}
        bodyStyle={bodyStyles}
        // maskStyle={{
        //   background: "rgba(17, 19, 23, 0.8)",
        // }}
      >
        <Row
          style={{ background: resultList?.themeColor }}
          justify="space-between"
          align="middle"
          className="modal_header"
        >
          <Col lg={23}>
            <p>{title}</p>
          </Col>
          <Col lg={1}>
            <img
              src={CloseIcon}
              alt=""
              onClick={handleModalVisibility}
              className="closeIconEvent"
            />
          </Col>
        </Row>
        <Row id="walletRow">
          <Col lg={8} style={{ background: "#F9F7F7" }}>
            <Row id="walletDescription">
              <p style={{ color: resultList?.themeColor }}>We Promise</p>
            </Row>
            <Col lg={24} className="walletCol">
              <ContactUsIcon />
              <h4 style={{ color: resultList?.themeColor }}>
                Instant Call Back
              </h4>
            </Col>
            <Col lg={24} className="walletCol">
              <CarVisitIcon />
              <h4 style={{ color: resultList?.themeColor }}>Free Site Visit</h4>
            </Col>
            <Col lg={24} className="walletCol">
              <LowPriceIcon />
              <h4 style={{ color: resultList?.themeColor }}>Unmatched Price</h4>
            </Col>
          </Col>
          <Col lg={15}>
            <RegisterForm
              subTitle={subTitle}
              btnText={btnText}
              actionType={actionType}
              handleModalVisibility={handleModalVisibility}
            />
          </Col>
        </Row>
      </Modal>
    </>
  );
};
